import * as R from 'ramda';
import React, { useState, useCallback } from 'react';
// helpers/constants
import * as G from '../helpers';
// utilities
import { sendRequest } from '../utilities/http';
///////////////////////////////////////////////////////////////////////////////////////////////////

const useAsyncReport = (props) => {
  const { openLoader, closeLoader, asyncReportOptions, asyncReportEndpoint } = props;

  const [asyncReportListState, setAsyncReportListState] = useState({ data: null, error: false, loading: true });

  const getReportListRequest = useCallback(async (requestAsyncReportOptions) => {
    if (G.isFunction(openLoader)) openLoader({ showDimmer: true });

    const options = R.or(requestAsyncReportOptions, asyncReportOptions);

    const res = await sendRequest('post', asyncReportEndpoint, options);

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      const dataToUse = R.pathOr(data, ['results'], data);

      if (G.isNotNil(dataToUse)) {
        setAsyncReportListState((prev) => ({
          ...prev,
          loading: false,
          data: G.setPropsWithValuesToArrayItems(dataToUse, [{ value: false, name: 'selected' }]),
        }));
      }
    } else {
      G.handleFailResponseSimple(res);
    }

    if (G.isFunction(closeLoader)) closeLoader();
  }, [asyncReportEndpoint]);

  const setSelectedItemToAsyncReport = useCallback((item) => {
    setAsyncReportListState((prev) => ({
      ...prev,
      data: G.selectItem(prev.data, item),
    }));
  }, []);

  return { asyncReportListState, getReportListRequest, setSelectedItemToAsyncReport };
};

const withAsyncReport = (Component) => (props) => {
  const report = useAsyncReport(props);

  return <Component {...props} {...report} />;
};

export { withAsyncReport };
